import { api } from './api';

export const taskService = {
    extractTasks: async (noteContent, mentionedUsers, noteId) => {
        try {
            const response = await api.post('/tasks/extract', {
                noteContent,
                mentionedUsers,
                noteId
            }, {
                timeout: 30000 // Increase timeout to 30 seconds
            });

            if (!response.data || !response.data.tasks) {
                throw new Error('Invalid response format from task extraction');
            }

            return response.data;
        } catch (error) {
            if (error.code === 'ECONNABORTED') {
                throw new Error('Task extraction is taking longer than expected. Please try again.');
            }
            throw error;
        }
    },

    createTasks: async (data) => {
        const payload = { tasks: Array.isArray(data) ? data : [data] };
        
        const response = await api.post('/tasks', payload);
        return response.data;
    },

    getTasksForNote: async (noteId) => {
        const response = await api.get(`/tasks/note/${noteId}`);
        return response.data;
    },

    getTasksForUser: async () => {
        const response = await api.get('/tasks/user');
        return response.data;
    },

    getTask: async (taskId) => {
        const response = await api.get(`/tasks/${taskId}`);
        return response.data;
    },

    updateTask: async (taskId, taskData) => {
        const response = await api.put(`/tasks/${taskId}`, taskData);
        return response.data;
    },

    deleteTask: async (taskId) => {
        const response = await api.delete(`/tasks/${taskId}`);
        return response.data;
    }
};
